import React, { useState } from 'react';
import { supabase } from '../../lib/supabase';
import { hashPassword } from '../../utils/auth';
import { Spinner } from './academyUtils';

export default function ChangePasswordCard({ studentId }) {
  const [form,    setForm]    = useState({ current:'', newPwd:'', confirm:'' });
  const [msg,     setMsg]     = useState(null); // { text, ok }
  const [loading, setLoading] = useState(false);

  async function handleSubmit() {
    setMsg(null);
    if (!form.current || !form.newPwd || !form.confirm) {
      setMsg({ text:'All fields are required.', ok:false }); return;
    }
    if (form.newPwd.length < 6) {
      setMsg({ text:'New password must be at least 6 characters.', ok:false }); return;
    }
    if (form.newPwd !== form.confirm) {
      setMsg({ text:'New passwords do not match.', ok:false }); return;
    }
    setLoading(true);
    try {
      const currentHash = await hashPassword(form.current);
      const { data, error: fetchErr } = await supabase
        .from('students').select('password_hash').eq('id', studentId).single();
      if (fetchErr || !data) { setMsg({ text:'Could not verify your account. Try again.', ok:false }); setLoading(false); return; }
      if (data.password_hash !== currentHash) { setMsg({ text:'Current password is incorrect.', ok:false }); setLoading(false); return; }
      const newHash = await hashPassword(form.newPwd);
      const { error: updErr } = await supabase.from('students').update({ password_hash: newHash }).eq('id', studentId);
      if (updErr) { setMsg({ text:'Failed to update password: ' + updErr.message, ok:false }); }
      else { setMsg({ text:'Password updated successfully.', ok:true }); setForm({ current:'', newPwd:'', confirm:'' }); }
    } catch { setMsg({ text:'Connection error. Please try again.', ok:false }); }
    setLoading(false);
  }

  return (
    <div style={{ background:'#fff', border:'1px solid #e8edf5', borderRadius:12, padding:'20px 24px', maxWidth:440 }}>
      <div style={{ fontWeight:600, fontSize:14, color:'#1a2a4a', marginBottom:4 }}>Change Password</div>
      <div style={{ fontSize:12.5, color:'#5a6a88', marginBottom:16, lineHeight:1.6 }}>
        Enter your current password, then choose a new one (minimum 6 characters).
      </div>

      {[['current','Current Password','••••••••'],['newPwd','New Password','at least 6 characters'],['confirm','Confirm New Password','repeat new password']].map(([field, label, ph]) => (
        <div key={field} style={{ marginBottom:12 }}>
          <div style={{ fontSize:10.5, fontFamily:"'JetBrains Mono',monospace", letterSpacing:'.13em', textTransform:'uppercase', color:'#9aa3b8', marginBottom:5 }}>{label}</div>
          <input type="password" value={form[field]} onChange={e => setForm(f => ({ ...f, [field]: e.target.value }))}
            placeholder={ph}
            style={{ width:'100%', background:'#f8f9fb', border:'1px solid #e8edf5', borderRadius:10, padding:'11px 14px', color:'#1a2233', fontSize:13.5, fontFamily:"'Plus Jakarta Sans',sans-serif", outline:'none', boxSizing:'border-box' }}/>
        </div>
      ))}

      {msg && (
        <div style={{ marginBottom:12, padding:'9px 13px', borderRadius:9, fontSize:12.5, lineHeight:1.55,
          background: msg.ok ? '#e8f5ee' : '#fff5f5',
          border: `1px solid ${msg.ok ? '#c8ead8' : 'rgba(192,57,43,0.2)'}`,
          color: msg.ok ? '#1a7a4a' : '#c0392b' }}>
          {msg.text}
        </div>
      )}

      <button onClick={handleSubmit} disabled={loading}
        style={{ width:'100%', background:'linear-gradient(135deg,#1a2a4a,#2a3a5a)', color:'#fff', border:'none', padding:'12px', borderRadius:10, fontSize:14, fontWeight:600, cursor:loading?'default':'pointer', fontFamily:"'Plus Jakarta Sans',sans-serif", opacity:loading?0.7:1, display:'flex', alignItems:'center', justifyContent:'center', gap:8 }}>
        {loading ? <Spinner/> : 'Update Password'}
      </button>
    </div>
  );
}
